
import firebase from 'firebase/app';

require('firebase/auth');
require('firebase/database');

export const config = {
	apiKey: 'AIzaSyC4hxlkVvWXg2J3oKTcDCyGkPBgMVG62nM',
	authDomain: 'payments-pwa.firebaseapp.com',
	databaseURL: 'https://payments-pwa.firebaseio.com',
	projectId: 'payments-pwa',
	storageBucket: 'payments-pwa.appspot.com',
	messagingSenderId: '506718306194',
	databaseName: `payments_${process.env.NODE_ENV}`
};

firebase.initializeApp(config);

export const database = firebase.database();
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();

export default firebase;



// WEBPACK FOOTER //
// ./firebaseConfig.js